export default __webpack_public_path__ + "static/media/woo-commerce-logo-icon.6a4de9ef.svg";